class FavouritesProvider {
  constructor() {
    this._favourites = [];
    this._isLoggedIn = !!(window.customerData && window.customerData.id);
    this.initialize();
  }

  get favourites() {
    return this._favourites;
  }

  set favourites(value) {
    this._favourites = value;

    if (!this._isLoggedIn) {
      localStorage.setItem('pr-favourites-products', JSON.stringify(value));
    }

    this.saveFavourites(value);
  }

  initialize() {
    if (this._isLoggedIn) {
      const initial = (window.customerData && window.customerData.favourites) || [];
      this._favourites = Array.isArray(initial) ? initial : [];
    } else {
      if (!localStorage.getItem('pr-favourites-products')) {
        this.favourites = [];
      } else {
        this._favourites = JSON.parse(localStorage.getItem('pr-favourites-products'));
      }
    }
  }

  toggleProduct(id) {
    if (this.favourites.includes(id)) {
      this.removeProduct(id);
    } else {
      this.addProduct(id);
    }
  }

  addProduct(id) {
    if (this.favourites.indexOf(id) === -1) {
      this.favourites = this.favourites.concat(id);
    }
  }

  removeProduct(id) {
    this.favourites = this.favourites.filter((favId) => favId !== id);
  }

  saveFavourites(value) {
    if (this._isLoggedIn) {
      this.saveFavouritesToCustomerMetafield(value);
    } else {
      this.saveFavouritesToApi(value);
    }
  }

  updateCount(count) {
    document.querySelectorAll('.favourites-bubble').forEach((b) => {
      b.textContent = count === 0 ? '' : count;
    });
  }

  saveFavouritesToApi(array) {
    this.updateCount(array.length);
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          favourites: array.join(','),
        },
      }),
    }).then((response) => response.json());
  }

  // NOWE: wysyłka do endpointu, który zapisze metafield
  saveFavouritesToCustomerMetafield(array) {
    // tu zakładam, że masz app proxy / endpoint w aplikacji
    fetch('/apps/customer-favourites', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        favourites: array, // np. ["123","456"]
      }),
    });
  }
}

window.FavouritesProvider = new FavouritesProvider();

class FavouritesButton extends HTMLElement {
  constructor() {
    super();
    this.icon = this.querySelector('svg');
    this.productId = this.getAttribute('data-product-id');
    this.removeOnClick = this.getAttribute('data-remove-on-click') === 'true';
    this._isActive = this.getIsActiveFromProvider();
    this.initialize();
  }

  set isActive(isActive) {
    this._isActive = isActive;
    this.setIconFill();
    if (!isActive && this.removeOnClick) {
      this.removeButtonAndHisParent();
    }
    if (!isActive) {
      this.dispatchDeleteEvent(this.productId);
    }
  }

  get isActive() {
    return this._isActive;
  }

  getIsActiveFromProvider() {
    return window.FavouritesProvider.favourites.includes(this.productId);
  }

  clickHandler() {
    window.FavouritesProvider.toggleProduct(this.productId);
    this.isActive = this.getIsActiveFromProvider();
  }

  removeButtonAndHisParent() {
    const card = this.closest('.card-wrapper.card-wrapper--product');
    if (card) card.remove();
  }

  setIconFill() {
    const shouldBeFilled = this.isActive && !this.removeOnClick;
    this.icon.setAttribute('fill', shouldBeFilled ? 'black' : 'none');
  }

  dispatchDeleteEvent(productId) {
    document.dispatchEvent(
      new CustomEvent('favourites:delete', {
        detail: {
          productId,
        },
      })
    );
  }

  initialize() {
    this.classList.remove('opacity-0');
    this.classList.remove('cursor-not-allowed');
    this.setIconFill();
    this.icon.addEventListener('click', this.clickHandler.bind(this));
  }
}
customElements.define('favourites-button', FavouritesButton);
